export const AUTH_APPROVAL_ROTATE_GRACE_MS = 10_000;
export const AUTH_APPROVAL_SOCKET_EVENT = 'auth_approval_status_changed';
export const AUTH_APPROVAL_SOCKET_PATH = '/sio';
